import { render, staticRenderFns } from "./PaymentMethodsChecker.vue?vue&type=template&id=3888e12e&"
import script from "./PaymentMethodsChecker.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports